import type { OvertimeRecord } from '@dxtech/shared';
import { call } from './library.js';

// 야근 API
export const overtimeApi = {
  mine: async () => (await (await call('/overtime/mine')).json()) as { items: OvertimeRecord[] },
  byDate: async (date: string) => (await (await call(`/overtime?date=${date}`)).json()) as { items: OvertimeRecord[] },
  history: async (upn: string, month: string) =>
    (await (await call(`/overtime/history?upn=${encodeURIComponent(upn)}&month=${month}`)).json()) as { items: OvertimeRecord[] },
  create: (date: string, start: string, end: string, reason: string) => call('/overtime', { date, start, end, reason }),
  act: (id: string, action: 'start' | 'end' | 'cancel') => call(`/overtime/${id}/${action}`, {}),
};
